import Cookies from 'universal-cookie'
import { CodonationCalculator, CodonationCalculatorModest } from '..'
import { ConfigOptions } from './types'

export function buildInitialValues({ config }: ConfigOptions) {
  const calc = CodonationCalculatorModest.appliesTo(config) ? CodonationCalculatorModest : CodonationCalculator
  const defaultCodonationCents = config.showCodonation ? calc.suggest(config.defaultDonationCents) : null

  const captchaFields = {
    captcha_solution: '',
    _captcha_complete: config.captchaComplete ?? false,
  }

  return {
    allow_data_transfer: false,
    amount_cents: config.defaultDonationCents,
    background_color: config.backgroundColor,
    bottom_logo: config.bottomLogo,
    channel: config.channel,
    city: '',
    client_reference: config.clientReference,
    codonation_cents: defaultCodonationCents || 0,
    color: config.color,
    company_name: '',
    country_alpha2: config.countryAlpha2,
    default_amount_cents: config.defaultDonationCents,
    default_codonation_cents: defaultCodonationCents,
    display_name: '',
    email: '',
    first_name: '',
    interval: config.defaultInterval,
    last_name: '',
    message: '',
    need_id: config.needId,
    newsletter: false,
    payment_method: config.defaultPaymentMethod,
    receiver_id: config.receiverId,
    receiver_type: config.receiverType,
    show_amount: true,
    show_user: false,
    street: '',
    stripe_token: '',
    tracking_via: computeTrackingVia({ config }),
    zip: '',
    receipt_desired: config.channel !== 'platform',
    // keys that start with "_" are not submitted with the form
    _codonation_calculator: calc,
    _company_donation: false,
    _show_codonation: config.showCodonation,
    _show_display_name: config.showDisplayName,
    _show_fake_buttons: config.showFakeButtons,
    _show_recurring: config.showRecurring,
    _show_platform_subscription: config.showPlatformSubscription,
    _payment_methods: config.paymentMethods,
    _recurring_payment_methods: config.recurringPaymentMethods,
    _step: 1,
    _submit_url: config.submitUrl,
    _tracking_ab: config.trackingAB,
    _tracking_newsletter_ab: config.trackingNewsletterAB,
    _debug: config.debug,
    ...captchaFields,
  }
}

const computeTrackingVia = ({ config }: ConfigOptions): string | undefined => {
  const { trackingVia, receiverType, receiverId } = config
  if (trackingVia) return trackingVia
  if (receiverType !== 'Project') return
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return new Cookies().get(`teaser-tracker-p${receiverId}`)
}
